import { modalStore } from '@/stores/modal';
import { pwaStore } from '@/stores/pwa';
import { getChannelFlag, getDevice, isInFacebookBrowser } from '@/utils/utils';

setTimeout(() => {
  pwaStore.init();
}, 3000);

window.addEventListener('appinstalled', () => {
  SingletonPrompt.getInstance().setInstalled('1');
});

export function callintent() {
  let url = location.href;
  url = url.replace('https://', '');
  url = url.replace('http://', '');
  const newLink =
    'intent://' + url + '#Intent;scheme=https;action=android.intent.action.VIEW;component=com.android.chrome;end';

  let a: any = document.getElementById('pwaIFrame');
  if (!a) {
    a = document.createElement('iframe');
    a.id = 'pwaIFrame';
    a.style.width = '0';
    a.style.height = '0';
    a.style.opacity = '0';
    a.name = 'pwaIFrame';
    document.body.appendChild(a);
  }

  a.src = newLink;
}

export const safeModalClick = () => {
  if (SingletonPrompt.getInstance().getPrompt()) {
    SingletonPrompt.getInstance().getPrompt()?.prompt();
    SingletonPrompt.getInstance()
      .getPrompt()
      ?.userChoice.then(choiceResult => {
        if (choiceResult.outcome === 'accepted') {
          pwaStore.setStatus(3);
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        SingletonPrompt.getInstance().resetPrompt();
      });
    modalStore.closeModal('pwa-safe-modal');
  } else {
    const source = getAPKCHSource();
    const flag = getChannelFlag();
    const url = `/${source}/${flag}/game` + location.search;
    window.open(url);
  }
};

export const safePreModalClick = () => {
  if (SingletonPrompt.getInstance().getPrompt()) {
    SingletonPrompt.getInstance().getPrompt()?.prompt();
    SingletonPrompt.getInstance()
      .getPrompt()
      ?.userChoice.then(choiceResult => {
        if (choiceResult.outcome === 'accepted') {
          pwaStore.setStatus(3);
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        SingletonPrompt.getInstance().resetPrompt();
      });
  } else {
    modalStore.openPwaSafeModal();
  }
  modalStore.closeModal('android-pwa-sofe-modal');
};

export const openBrowser = () => {
  const installed = SingletonPrompt.getInstance().getInstalled();
  if (installed) {
    const url = 'game' + location.search;
    window.open(url);
  } else {
    modalStore.openAndroidPwaSafe();
  }
};

export const installPwa = () => {
  const device = getDevice();
  if (device === 'ios') {
    modalStore.openIosPwa();
  } else {
    const isChrome = navigator.userAgent.indexOf('Chrome') > -1;
    if (isInFacebookBrowser() || !isChrome) {
      callintent();
    } else if (SingletonPrompt.getInstance().getPrompt()) {
      SingletonPrompt.getInstance().getPrompt()?.prompt();

      SingletonPrompt.getInstance()
        .getPrompt()
        ?.userChoice.then(choiceResult => {
          if (choiceResult.outcome === 'accepted') {
            pwaStore.setStatus(3);
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          SingletonPrompt.getInstance().resetPrompt();
        });
    } else {
      setTimeout(() => {
        modalStore.openAndroidPwaSafe();
      }, 0);
    }
  }
};
